export default __webpack_public_path__ + "static/media/referralIcon.abcbb4f1.svg";